import { Box, Divider } from '@mui/material';
import ButtonGroup from '../Components/ButtonGroup';
import AlignButtons from './AlignButtons';
import ColorButtons from './ColorButtons';
import DirButtons from './DirButtons';
import FontSize from './FontSize';
import FormatButtons from './FormatButtons';
import SelectFont from './SelectFont';
import RemoveFormat from './RemoveFormat';
import LinkButton from './LinkButton';
import SelectHeading from './SelectHeading';
import ListButtons from './ListButtons';
import useSelectedElement from '../hooks/useSelectedElement';
import { useSlate } from 'slate-react';
import { Node } from 'slate';

function ToolDivider() {
    return <Divider flexItem orientation="vertical" sx={{ mx: 0.5, my: 1 }} />;
}

// Link

function ToolbarWraper({ children }) {
    return (
        <Box
            sx={{
                height: 64,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                py: 1.5,
                borderBottom: 1,
                borderColor: 'divider',
                boxShadow: theme => `0px 0px 5px 0px ${theme.palette.divider}`,
            }}
        >
            <ButtonGroup sx={{ borderRadius: 99 }}>{children}</ButtonGroup>
        </Box>
    );
}

function TextToolbar() {
    return (
        <ToolbarWraper>
            <SelectHeading />
            <ToolDivider />
            <SelectFont />
            <ToolDivider />
            <FontSize />
            <ToolDivider />
            <FormatButtons />
            <ToolDivider />
            <ColorButtons />
            <ToolDivider />
            <AlignButtons />
            <ToolDivider />
            <LinkButton />
            <ToolDivider />
            <ListButtons />
            <ToolDivider />
            <DirButtons />
            <ToolDivider />
            <RemoveFormat />
        </ToolbarWraper>
    );
}

function ButtonToolbar() {
    return (
        <ToolbarWraper>
            <SelectFont />
            <ToolDivider />
            <FontSize />
            <ToolDivider />
            <FormatButtons />
            <ToolDivider />
            <DirButtons />
            <ToolDivider />
            <RemoveFormat />
        </ToolbarWraper>
    );
}

function EmptyToolbar() {
    const editor = useSlate();
    const backgroundColor = Node.get(editor, [0, 0])?.attributes?.style
        ?.backgroundColor;

    return <div style={{ height: 64 }}></div>;
}

function Toolbar() {
    const { getSelectedElement } = useSelectedElement();
    const [selectedElement] = getSelectedElement();

    if (selectedElement?.type === 'rich-text') return <TextToolbar />;
    if (selectedElement?.type === 'button') return <ButtonToolbar />;
    return <EmptyToolbar />;
}

export default Toolbar;
